// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__u7Llo","productName":"Table_productName__2lUqe"};